import { ServiceType } from './service-type.enum';

export class ServiceProperties {
	serviceType: ServiceType;
	productId: string;
}
